import {AfterViewInit, Component, Input, ViewEncapsulation} from '@angular/core';
import {Kpi} from '../../../models/common';
import {PdfExportService} from '../../services/export-pdf/pdf-export.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'kpi-report',
  templateUrl: './kpi-report.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./kpi-report.component.scss']
})
export class KpiReportComponent implements AfterViewInit {

  @Input()
  public kpi: Kpi;

  @Input()
  public showKpiStatus: boolean | false;

  @Input()
  public showMentionsKpi = false;

  constructor(private pdfService: PdfExportService, private translate: TranslateService) {

  }

  ngAfterViewInit() {
    this.pdfService.incrementNumberReportReady('KpiReportComponent');
  }

  getTooltipInfo(kpiType) {
    return this.kpi && this.kpi.isAverage
      ? this.translate.instant(`info_box.influencer.avg_${kpiType}`)
      : this.translate.instant(`info_box.influencer.${kpiType}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/main/kpi-report/kpi-report.component.ts